import { useState } from "react";
import { FiltroEndosoMasivo } from "../models/filtroEndosoMasivo";
import { getInversionistasService } from "../services/generalServices";
import { buscarEndososEnCartera, grabarOperacion } from "../services/endosoServices";
import { RowEndosoMasivo } from "../models/rowEndosoMasivo";
import { MutuoSeleccionadoEndoso } from "../models/mutuoSeleccionadoEndoso";
import { MutuoModificacionEndoso } from "../models/mutuoModificacionEndoso";
import { GrabarOperacionEndoso } from "../models/grabarOperacionEndoso";
import { FiltroGeneracionMasiva } from "../../generacionmasiva/models/filtroGeneracionMasiva";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { selectorTransversal } from "../../../../dtos/selector";


export default function UseEndosoMasivo(){

    const [defaultValues, setDefaultValues] = useState<FiltroEndosoMasivo>({
        fechaEndoso: new Date(),
        institucion: ""
    })

    const [defaultValuesGenMasiva, setDefaultValuesGenMasiva] = useState<FiltroGeneracionMasiva>({
        fechaDesde: new Date(),
        fechaOperacion: new Date(),
        inversionista: ""
    })

    const [inversionistas, setInversionistas] = useState<selectorTransversal[]>([]);

    const getInversionistas = async() => {
        const response: AxiosResponse<ListResponseDto<selectorTransversal>> = await getInversionistasService();
        setInversionistas(response.data.items);
    }

    const buscarEndosos = async (fechaEndoso: Date, inversionista: string) : Promise<RowEndosoMasivo[]> => {
        const response: AxiosResponse<ListResponseDto<RowEndosoMasivo>> = await buscarEndososEnCartera(fechaEndoso, inversionista);
        if (response.status === 200){
            return response.data.items;
        }
        return [];
    }

    const grabarEndosos = async (fechaEndoso: Date, rutInversionista: string, mutuosSeleccionados: MutuoSeleccionadoEndoso[]) => {
        const mutuosEndoso : MutuoModificacionEndoso[] = []
        for (const mutuo of mutuosSeleccionados){
            const mutuoEndoso : MutuoModificacionEndoso = {id: mutuo.id, tasaEndoso: mutuo.tasaEndoso, 
                                                            numCuponesCortados: mutuo.numCuponesCortados,
                                                            fechaRemesa: mutuo.fechaRemesa}
            mutuosEndoso.push(mutuoEndoso)
        }
        const grabarOperacionDto : GrabarOperacionEndoso = {fechaEndoso, inversionista: rutInversionista, mutuosSeleccionados: mutuosEndoso}
        return await grabarOperacion(grabarOperacionDto);
    }

    return {
        defaultValues,
        setDefaultValues,
        defaultValuesGenMasiva,
        setDefaultValuesGenMasiva,
        inversionistas,
        getInversionistas,
        buscarEndosos,
        grabarEndosos
    }
}